
    // Populate the dynamic swatches/spacing/radii grids
    function build() {
      const palette = [
        ['Primary', '--ry-color-primary'],
        ['Primary hover', '--ry-color-primary-hover'],
        ['Secondary', '--ry-color-secondary'],
        ['Accent', '--ry-color-accent'],
        ['Accent hover', '--ry-color-accent-hover'],
      ];
      const semantic = [
        ['Success', '--ry-color-success'],
        ['Warning', '--ry-color-warning'],
        ['Danger', '--ry-color-danger'],
        ['Info', '--ry-color-info'],
      ];
      const extended = [
        ['Red', '--ry-color-red'],
        ['Orange', '--ry-color-orange'],
        ['Yellow', '--ry-color-yellow'],
        ['Olive', '--ry-color-olive'],
        ['Green', '--ry-color-green'],
        ['Teal', '--ry-color-teal'],
        ['Blue', '--ry-color-blue'],
        ['Violet', '--ry-color-violet'],
        ['Purple', '--ry-color-purple'],
        ['Pink', '--ry-color-pink'],
        ['Brown', '--ry-color-brown'],
        ['Grey', '--ry-color-grey'],
        ['Black', '--ry-color-black'],
      ];
      const neutrals = [
        ['Background', '--ry-color-bg'],
        ['Subtle', '--ry-color-bg-subtle'],
        ['Muted', '--ry-color-bg-muted'],
        ['Border', '--ry-color-border'],
        ['Text', '--ry-color-text'],
        ['Text muted', '--ry-color-text-muted'],
      ];
      const space = ['1','2','3','4','5','6','8','10','12','16','20'];
      const radii = ['sm','md','lg','xl','2xl','full'];
      const shadows = ['sm','md','lg','xl'];

      const swatchHTML = (rows) => rows.map(([label, prop]) =>
        `<div class="swatch"><div class="chip" style="background: var(${prop})"></div><div class="label">${label}</div><div class="value">${prop.replace('--ry-color-','')}</div></div>`
      ).join('');

      document.getElementById('swatch-palette').innerHTML = swatchHTML(palette);
      document.getElementById('swatch-semantic').innerHTML = swatchHTML(semantic);
      document.getElementById('swatch-extended').innerHTML = swatchHTML(extended);
      document.getElementById('swatch-neutrals').innerHTML = swatchHTML(neutrals);

      document.getElementById('space-scale-row').innerHTML = space.map(s =>
        `<div><div class="space-bar" style="width: var(--ry-space-${s})"></div><div class="label" style="font-size:var(--ry-text-xs);color:var(--ry-color-text-muted)">space-${s}</div></div>`
      ).join('');

      document.getElementById('radii-row').innerHTML = radii.map(r =>
        `<div><div class="radius-tile" style="border-radius: var(--ry-radius-${r})"></div><div class="label" style="font-size:var(--ry-text-xs);color:var(--ry-color-text-muted)">${r}</div></div>`
      ).join('');

      document.getElementById('shadows-row').innerHTML = shadows.map(s =>
        `<div style="background: var(--ry-color-bg); border-radius: var(--ry-radius-md); padding: var(--ry-space-4); box-shadow: var(--ry-shadow-${s})"><div class="label" style="font-size:var(--ry-text-xs);color:var(--ry-color-text-muted)">shadow-${s}</div></div>`
      ).join('');
    }
    build();
  